import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
  inject,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { DateAdapter, provideNativeDateAdapter } from '@angular/material/core';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  MatTimepicker,
  MatTimepickerInput,
} from '@angular/material/timepicker';

import { DATE_ADAPTER_FORMATS_24H, is12HourFormat } from '@core-utils';

@Component({
  selector: 'ui-form-timepicker',
  imports: [
    MatFormField,
    MatInput,
    MatTimepickerInput,
    ReactiveFormsModule,
    MatTimepicker,
    FormsModule,
  ],
  templateUrl: './form-timepicker.component.html',
  styleUrl: './form-timepicker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideNativeDateAdapter()],
})
export class FormTimepickerComponent {
  private dateAdapter = inject<DateAdapter<Date>>(DateAdapter);

  control = input<AbstractControl>();
  placeholderTime = input<string>('Chose Time');
  selectedDate = model<string | Date | null>(new Date());
  timeChange = output<Date>();

  constructor() {
    if (!is12HourFormat()) {
      this.dateAdapter.setLocale(DATE_ADAPTER_FORMATS_24H);
    }
  }

  get formControl(): FormControl {
    return this.control() as FormControl;
  }

  onTimeChange(event: Date) {
    this.timeChange.emit(event);
  }
}
